import { enqueueSnackbar } from '@paragon/notification-tools';

import { clearDelayedNotifications } from '../slices/delayedNotificationsSlice';
import { ThunkActionVoid } from './thunkActions';

export const showDelayedNotifications =
  (componentDesignGuid: string): ThunkActionVoid =>
  (dispatch, getState) => {
    const notifications = getState().delayedNotifications[componentDesignGuid];
    if (notifications == null || notifications.length === 0) return;

    for (const notification of notifications) {
      dispatch(enqueueSnackbar(notification));
    }

    dispatch(clearDelayedNotifications({ componentDesignGuid }));
  };
